import { useMutation, useQueryClient } from '@tanstack/react-query';
import { useAccessToken } from '../useProfile';

type UseDeletePlanOptions = {
  onSuccess?: () => void;
  onError?: (error: Error) => void;
};

export const useDeletePlan = ({
  onSuccess,
  onError,
}: UseDeletePlanOptions = {}) => {
  const { data: accessToken } = useAccessToken();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: async (racePlanId: number) => {
      const response = await fetch(
        `${import.meta.env.REACT_APP_API_SERVICE_URI}/api/profile/plan/${racePlanId}/delete`,
        {
          method: 'DELETE',
          headers: {
            Authorization: `Bearer ${accessToken}`,
          },
        },
      );
      if (!response.ok) {
        throw new Error('Failed to delete plan');
      }
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: ['racePlan'] });
      await queryClient.invalidateQueries({ queryKey: ['plannedWorkouts'] });
      onSuccess?.();
    },
    onError,
  });
};
